'use client';

import clsx from 'clsx';
import { useContext } from 'react';
import { CgCloseR } from 'react-icons/cg';

import { isBlank } from 'shared/lib/utils';

import { StateContext } from '@/lib/StateProvider';

export function FlashMessage({ message, type, showClose = true }) {
  const { dispatch } = useContext(StateContext);

  if (isBlank(message)) {
    return null;
  }

  return (
    <div
      className={clsx([
        'sticky bottom-0 flex flex-col p-8 sm:flex-row sm:items-center ',
        type === 'error' && 'bg-red-200',
        type === 'success' && 'bg-green-200',
      ])}
    >
      <div className="order-2 max-w-prose basis-full space-y-1 text-left sm:order-1 md:mx-auto">
        {message}
      </div>

      {(() => {
        if (!showClose) {
          return null;
        }

        return (
          <button
            type="button"
            className="order-1 place-self-end sm:order-2 sm:place-self-start"
            onClick={(_e) =>
              dispatch({
                type: 'setFlashMessage',
                data: null,
              })
            }
          >
            <CgCloseR size="1.5rem" />
          </button>
        );
      })()}
    </div>
  );
}

function FlashMessages() {
  const { state } = useContext(StateContext);

  return (
    <FlashMessage
      type={state.getIn(['flashMessage', 'type'])}
      message={state.getIn(['flashMessage', 'message'])}
    />
  );
}

export default FlashMessages;
